import { z } from "zod"
import { type OEBackendScalar } from "@/graphql"

export type SuggestedPowerAdjustment = OEBackendScalar<"SuggestedPowerAdjustment">

const SuggestedPowerAdjustment = {
    HIGHER: "HIGHER",
    LOWER: "LOWER",
    NONE: "NONE",
} as const satisfies Record<SuggestedPowerAdjustment, SuggestedPowerAdjustment>

export const SuggestedPowerAdjustmentSchema = z.enum(SuggestedPowerAdjustment)
